import { useEffect, useState } from "react";
import { Lightbulb, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

/**
 * One short, child-specific suggestion the caregiver can act on today.
 * Cached on the backend per profile/day so reloading is free.
 */
export default function DailyTip({ profileId }) {
  const [tip, setTip] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/profiles/${profileId}/daily-tip`);
        if (alive) setTip(data.tip || "");
      } catch (err) {
        if (alive) setError(true);
        console.warn("DailyTip: fetch failed", err?.response?.status || err?.message);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [profileId]);

  if (error) return null;

  return (
    <div
      className="brutal-card bg-[#FFF7E1] p-3 mb-3 flex items-start gap-2 text-sm"
      data-testid={`daily-tip-${profileId}`}
    >
      <span className="shrink-0 w-7 h-7 rounded-full bg-[color:var(--gold)] border-[2.5px] border-[color:var(--ink)] flex items-center justify-center">
        {loading ? (
          <Loader2 size={13} className="animate-spin" />
        ) : (
          <Lightbulb size={13} />
        )}
      </span>
      <div className="flex-1 min-w-0">
        <div className="display font-bold text-xs uppercase tracking-[0.2em] text-[color:var(--ink-soft)]">
          Today's tip
        </div>
        <div className="leading-snug mt-0.5">
          {loading ? "Coach is thinking…" : tip}
        </div>
      </div>
    </div>
  );
}
